import { jsxs as r, jsx as e } from "react/jsx-runtime";
import { Check as m, X as h, Settings as y, Pencil as x, RefreshCw as f } from "lucide-react";
import { forwardRef as g } from "react";
import { A as v } from "./Avatar-ihLwDM5D.js";
import { B as o } from "./Button-icgr8OM9.js";
import { A as S } from "./AiModeBadge-DXU_Al41.js";
import { S as z } from "./SourcePill-CgQffD-I.js";
import { S as A, c as C, a as k } from "./SidePanel-Djuk8hmu.js";
function a({ eyebrow: n, children: t }) {
  return /* @__PURE__ */ r(
    "section",
    {
      style: {
        padding: "var(--space-4) 0",
        borderBottom: "1px solid var(--border-subtle)"
      },
      children: [
        /* @__PURE__ */ e(
          "div",
          {
            style: {
              fontSize: "var(--text-2xs)",
              color: "var(--text-tertiary)",
              letterSpacing: "0.06em",
              textTransform: "uppercase",
              marginBottom: "var(--space-2)"
            },
            children: n
          }
        ),
        /* @__PURE__ */ e("div", { style: { fontSize: "var(--text-sm)", color: "var(--text-primary)" }, children: t })
      ]
    }
  );
}
const L = g(function({ conv: t, labels: i, onClose: s, onNavSettings: c, onReplyManually: d, onReassignSource: l, width: p = 240 }, u) {
  return /* @__PURE__ */ r(
    A,
    {
      ref: u,
      side: "right",
      width: p,
      "aria-label": i.ariaLabel,
      "data-ls-component": "context-panel",
      "data-conv-id": t.id,
      "data-ai-mode": t.aiMode,
      children: [
        /* @__PURE__ */ e(C, { title: i.title, onClose: s, closeLabel: i.closeLabel }),
        /* @__PURE__ */ r(k, { children: [
          /* @__PURE__ */ e(a, { eyebrow: i.sections.account, children: /* @__PURE__ */ r("div", { style: { display: "flex", alignItems: "center", gap: "var(--space-3)" }, children: [
            /* @__PURE__ */ e(
              v,
              {
                size: "sm",
                tone: "identity",
                identityColor: t.accountColor,
                initials: t.initials,
                alt: t.accountLabel
              }
            ),
            /* @__PURE__ */ r("div", { style: { minWidth: 0 }, children: [
              /* @__PURE__ */ e("div", { style: { fontWeight: 600 }, children: t.accountLabel }),
              /* @__PURE__ */ e("div", { style: { fontSize: "var(--text-2xs)", color: "var(--text-tertiary)" }, children: t.accountSubtitle })
            ] })
          ] }) }),
          /* @__PURE__ */ r(a, { eyebrow: i.sections.business, children: [
            /* @__PURE__ */ e("div", { children: t.business }),
            /* @__PURE__ */ e(
              "div",
              {
                style: {
                  fontSize: "var(--text-2xs)",
                  color: "var(--text-tertiary)",
                  marginTop: "var(--space-1)"
                },
                children: t.businessDescription
              }
            )
          ] }),
          /* @__PURE__ */ e(a, { eyebrow: i.sections.campaign, children: t.campaign ? /* @__PURE__ */ e("span", { children: t.campaign }) : /* @__PURE__ */ e("span", { style: { fontStyle: "italic", color: "var(--text-tertiary)" }, children: i.noCampaignPlaceholder }) }),
          /* @__PURE__ */ r(a, { eyebrow: i.sections.source, children: [
            /* @__PURE__ */ e("div", { style: { display: "flex", alignItems: "center", gap: "var(--space-2)" }, children: /* @__PURE__ */ e(z, { source: t.source, children: i.sourceLabel }) }),
            /* @__PURE__ */ r(
              "div",
              {
                style: {
                  marginTop: "var(--space-2)",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "var(--space-1)",
                  fontSize: "var(--text-2xs)",
                  color: t.sourceAutoDetected ? "var(--success)" : "var(--text-tertiary)"
                },
                children: [
                  t.sourceAutoDetected ? /* @__PURE__ */ e(m, { size: 12, "aria-hidden": "true" }) : /* @__PURE__ */ e(h, { size: 12, "aria-hidden": "true" }),
                  /* @__PURE__ */ e("span", { children: t.sourceAutoDetected ? i.sourceAutoDetected : i.sourceManual })
                ]
              }
            )
          ] }),
          /* @__PURE__ */ r(a, { eyebrow: i.sections.aiMode, children: [
            /* @__PURE__ */ e("div", { style: { display: "flex", alignItems: "center", gap: "var(--space-2)" }, children: /* @__PURE__ */ e(S, { mode: t.aiMode, children: i.aiModeLabel }) }),
            /* @__PURE__ */ e(
              "p",
              {
                style: {
                  margin: 0,
                  marginTop: "var(--space-2)",
                  fontSize: "var(--text-2xs)",
                  color: "var(--text-secondary)",
                  lineHeight: 1.4
                },
                children: i.aiModeDescription
              }
            ),
            /* @__PURE__ */ r(
              "button",
              {
                type: "button",
                onClick: () => c?.(t.accountId),
                style: {
                  marginTop: "var(--space-2)",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "var(--space-1)",
                  padding: 0,
                  border: "none",
                  background: "transparent",
                  color: "var(--accent-default)",
                  fontSize: "var(--text-2xs)",
                  cursor: "pointer",
                  textDecoration: "underline"
                },
                children: [
                  /* @__PURE__ */ e(y, { size: 11, "aria-hidden": "true" }),
                  i.aiSettingsLink
                ]
              }
            )
          ] }),
          /* @__PURE__ */ r("section", { style: { paddingTop: "var(--space-4)" }, "aria-label": i.sections.quickActions, children: [
            /* @__PURE__ */ e(
              "div",
              {
                style: {
                  fontSize: "var(--text-2xs)",
                  color: "var(--text-tertiary)",
                  letterSpacing: "0.06em",
                  textTransform: "uppercase",
                  marginBottom: "var(--space-2)"
                },
                children: i.sections.quickActions
              }
            ),
            /* @__PURE__ */ r("div", { style: { display: "flex", flexDirection: "column", gap: "var(--space-2)" }, children: [
              /* @__PURE__ */ e(
                o,
                {
                  variant: "ghost",
                  size: "sm",
                  fullWidth: !0,
                  iconLeft: /* @__PURE__ */ e(x, { size: 12, "aria-hidden": "true" }),
                  onClick: () => d?.(t.id),
                  children: i.quickActions.replyManually
                }
              ),
              /* @__PURE__ */ e(
                o,
                {
                  variant: "ghost",
                  size: "sm",
                  fullWidth: !0,
                  iconLeft: /* @__PURE__ */ e(f, { size: 12, "aria-hidden": "true" }),
                  onClick: () => l?.(t.id),
                  children: i.quickActions.reassignSource
                }
              )
            ] })
          ] })
        ] })
      ]
    }
  );
});
L.displayName = "ContextPanel";
export {
  L as C
};
//# sourceMappingURL=ContextPanel-DayzGryz.js.map
